// Shop Labour Rate Calculator maths (mirrors backend/rate_calc.py).
export const YEARLY_FACTOR = { daily: 365, weekly: 52, monthly: 12, yearly: 1 };
export const OVERHEAD_FREQS = ["daily", "weekly", "monthly", "yearly"];
export const WAGE_FREQS = ["hourly", "weekly", "monthly", "yearly"];

export const n = (v) => (Number.isFinite(+v) ? +v : 0);

// Staff member's wage expressed weekly (= hourly equivalent x weekly hours).
export const staffWeeklyCost = (row) =>
  row.wage_frequency === "hourly"
    ? n(row.wage_amount) * n(row.weekly_hours)
    : (n(row.wage_amount) * (YEARLY_FACTOR[row.wage_frequency] || 1)) / 52;

export const staffHourly = (row) =>
  row.wage_frequency === "hourly" ? n(row.wage_amount) : n(row.weekly_hours) > 0 ? staffWeeklyCost(row) / n(row.weekly_hours) : 0;

// Same wage re-expressed in another unit (hourly uses the person's weekly hours).
export const convertStaffAmount = (row, toFreq) => {
  const weekly = staffWeeklyCost(row);
  if (toFreq === "hourly") return n(row.weekly_hours) > 0 ? weekly / n(row.weekly_hours) : n(row.wage_amount);
  if (row.wage_frequency === "hourly" && !(n(row.weekly_hours) > 0)) return n(row.wage_amount);
  return (weekly * 52) / (YEARLY_FACTOR[toFreq] || 1);
};

export const rowYearly = (row) => n(row.amount) * (YEARLY_FACTOR[row.frequency] || 1);

export const rowCells = (row) => {
  const yearly = rowYearly(row);
  return { daily: yearly / 365, weekly: yearly / 52, monthly: yearly / 12, yearly };
};

export const computeRate = (inp) => {
  const hours = n(inp.hours_per_week);
  const util = n(inp.utilization_pct);
  const downtime = n(inp.downtime_weeks);
  const margin = n(inp.margin_pct);
  const staff = inp.staff || [];
  const weeklyBillable = (hours * util) / 100;
  const availableWeeks = Math.max(52 - downtime, 0);
  // Billable hours = shop hours only (not multiplied by headcount) — owner's choice.
  const annualBillableHours = weeklyBillable * availableWeeks;
  const weeklyLabour = staff.reduce((s, r) => s + staffWeeklyCost(r), 0);
  const annualLabour = weeklyLabour * 52;
  const annualOverhead = (inp.overheads || []).reduce((s, r) => s + rowYearly(r), 0);
  const total = annualLabour + annualOverhead;
  const trueHourly = annualBillableHours > 0 ? total / annualBillableHours : 0;
  const suggested = margin < 100 ? trueHourly / (1 - margin / 100) : 0;
  return {
    weeklyBillable,
    availableWeeks,
    annualBillableHours,
    weeklyLabour,
    annualLabour,
    annualOverhead,
    total,
    trueHourly,
    suggested: Math.round(suggested * 100) / 100,
    labourShare: total > 0 ? annualLabour / total : 0,
  };
};

export const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));

export const money = (v, digits = 2) =>
  `$${n(v).toLocaleString("en-AU", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;

export const round2 = (v) => Math.round(n(v) * 100) / 100;
